import { render, staticRenderFns } from "./SafetyObservationItemView.vue?vue&type=template&id=1bb7bd88"
import script from "./SafetyObservationItemView.vue?vue&type=script&lang=js"
export * from "./SafetyObservationItemView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports